import type { ELineStyle } from '@common/enums';

export type AdvancedBorderSettings = {
    isActive: boolean;
    isIndependentBorders: boolean;
    borderTopWidth: number;
    borderTopColor: string;
    borderTopStyle: ELineStyle;
    borderRightWidth: number;
    borderRightColor: string;
    borderRightStyle: ELineStyle;
    borderBottomWidth: number;
    borderBottomColor: string;
    borderBottomStyle: ELineStyle;
    borderLeftWidth: number;
    borderLeftColor: string;
    borderLeftStyle: ELineStyle;
};

export enum EBorderSide {
    all = 'all',
    top = 'top',
    right = 'right',
    bottom = 'bottom',
    left = 'left',
}
